import MessageIcon from '@material-ui/icons/ViewList';

import MessageList from './ParkingPartnerList';
import MessageCreate from './ParkingPartnerCreate';
import MessageEdit from './ParkingPartnerEdit';

export default {
    list: MessageList,
    create: MessageCreate,
    edit: MessageEdit,
    icon: MessageIcon,
};
